import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet';
import appConfig from '@/config';

/**
 * 画面タイトル表示
 * @param  {string} {pageTitle}
 * @return {object}
 */
function PageTitleInformation({pageTitle}) {
  const browserTitle = pageTitle
      ? appConfig.sysTitle + ' ' + pageTitle
      : appConfig.sysTitle;
  return (
    <React.Fragment>
      <Helmet>
        <title>{browserTitle}</title>
      </Helmet>
      <Box component="div" sx={{ my: 2 }}>
        <Typography variant="h6">
          <Box component="span"
            sx={{
              borderBottom: 'solid 1px gray',
              color: '#000',
              background: '#fff',
              fontWeight: 'bold'}}>
            {pageTitle}
          </Box>
        </Typography>
      </Box>
    </React.Fragment>
  );
};

PageTitleInformation.propTypes = {
  pageTitle: PropTypes.string,
};

export default PageTitleInformation;
